import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import Skeleton from "react-loading-skeleton";
import { EmptyListNotice, Table } from "@hatch-digital-nl/abs-storybook/legacy";
import { getTableColumns } from "../utils/getTableColumns";
import { getTableRows } from "../utils/getTableRows";
import { useEstablishmentId } from "../../../common/utils/useEstablishmentId";
import ellipsisImage from "../../../common/images/ellipsis.svg";
import ellipsisWhiteImage from "../../../common/images/ellipsis-white.svg";
import {
    setCurrentPage,
    setItemsPerPage,
} from "../ScheduledQualificationsSlice";
import React, { JSX } from "react";
import {
    useDeleteScheduledQualificationMutation,
    useGetEmployeeScheduledQualificationsQuery,
} from "../../../common/api/scheduledQualification";
import { DeleteScheduledQualificationModal } from "./DeleteScheduledQualificationModal";
import { useEmployeeId } from "../../../common/utils/useEmployeeId";
import { useIsEstablishmentManager } from "../../../common/utils/useIsEstablishmentManager";

export const ScheduledQualificationsContent = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const isEstablishmentManager = useIsEstablishmentManager();
    const employeeId = useEmployeeId();
    const { currentPage, itemsPerPage, itemsPerPageSelect, searchTerm, sort } =
        useAppSelector((state) => state.scheduledQualifications);
    const {
        data: employeeScheduledQualifications,
        isLoading: employeeScheduledQualificationsIsLoading,
        isFetching: employeeScheduledQualificationsIsFetching,
    } = useGetEmployeeScheduledQualificationsQuery({
        page: currentPage,
        items_per_page: itemsPerPage,
        sort: sort.sortName,
        filter: {
            search: searchTerm,
            establishment_id: useEstablishmentId(),
            ...(!isEstablishmentManager ? { employee_id: employeeId } : {}),
        },
    });

    const [
        deleteScheduledQualification,
        { isLoading: isDeleteScheduledQualificationLoading },
    ] = useDeleteScheduledQualificationMutation();

    if (
        employeeScheduledQualificationsIsLoading ||
        employeeScheduledQualificationsIsFetching
    ) {
        return <Skeleton height={"60rem"} borderRadius={"1.5rem"} />;
    }

    if (
        !employeeScheduledQualifications ||
        !employeeScheduledQualifications.data ||
        !employeeScheduledQualifications.meta ||
        !employeeScheduledQualifications.data.length
    ) {
        return (
            <div className="p-scheduled-qualifications__content">
                <EmptyListNotice
                    content={"Er zijn geen ingeplande kwalificaties gevonden"}
                />
            </div>
        );
    }

    return (
        <div className="p-scheduled-qualifications__content">
            <Table
                data={{
                    columns: getTableColumns({
                        dispatch,
                        sort,
                        isEstablishmentManager,
                    }),
                    rows: getTableRows({
                        employeeScheduledQualifications:
                            employeeScheduledQualifications.data,
                        dispatch,
                        isEstablishmentManager,
                    }),
                    total: employeeScheduledQualifications.meta.total,
                }}
                iconButtonIconUrl={ellipsisImage}
                iconButtonBackgroundColor={"#F3F4F6"}
                onOpenIconButtonUrl={ellipsisWhiteImage}
                onOpenIconButtonBackgroundColor={"#1D2D58"}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                itemsPerPageSelect={itemsPerPageSelect}
                onItemsPerPageChange={(
                    event: React.ChangeEvent<HTMLSelectElement>,
                ) => dispatch(setItemsPerPage(Number(event.target.value)))}
                onPaginationChange={(page: number) =>
                    dispatch(setCurrentPage(page))
                }
                isPagination={true}
            />
            <DeleteScheduledQualificationModal
                deleteScheduledQualification={deleteScheduledQualification}
                isDeleteScheduledQualificationLoading={
                    isDeleteScheduledQualificationLoading
                }
            />
        </div>
    );
};
